import { PlanCurrencies, PlanFrequencies } from 'api/authentication/requests';

export type PricedPlan = 'business' | 'premium';

export const PRICE_MAP: Record<
  PlanFrequencies,
  Record<PlanCurrencies, Record<PricedPlan, string>>
> = {
  monthly: {
    USD: {
      business: '$349',
      premium: '$1,190',
    },
    EUR: {
      business: '€290',
      premium: '€990',
    },
    GBP: {
      business: '£259',
      premium: '£865',
    },
  },
  yearly: {
    USD: {
      business: '$291',
      premium: '$992',
    },
    EUR: {
      business: '€242',
      premium: '€825',
    },
    GBP: {
      business: '£216',
      premium: '£721',
    },
  },
};

export const hasPriceList = (currency: string): currency is PlanCurrencies => {
  return currency in PRICE_MAP.monthly;
};

export const resolveSelectedCurrency = (planCurrency: string, isLocked: boolean): string => {
  if (isLocked) {
    return planCurrency;
  }
  return hasPriceList(planCurrency) ? planCurrency : 'USD';
};

export const getPlanPrice = (
  currency: string,
  frequency: PlanFrequencies,
  plan: PricedPlan
): string | null => {
  if (!hasPriceList(currency)) {
    return null;
  }
  return PRICE_MAP[frequency][currency][plan];
};
